import {hoistCmp, uses} from '@xh/hoist/core';
import {DataCheckDialogModel} from './DataCheckDialogModel';
import {dialog} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import './DataCheckDialog.scss';

export const dataCheckDialog = hoistCmp.factory<DataCheckDialogModel>({
    model: uses(DataCheckDialogModel),
    render({model}) {
        return dialog({
            className: 'data-check-dialog',
            isOpen: model.isOpen,
            onClose: () => model.close(),
            title: 'Data Consistency Checks',
            icon: Icon.checkCircle(),
            item: panel({
                scrollable: true,
                contentBoxProps: {className: 'data-check-dialog__container'},
                items: [grid({model: model.gicsGrid}), grid({model: model.betaGrid}), grid({model: model.dividendGrid})],
                mask: model.apiTask
            })
        });
    }
});
